module.exports = __webpack_public_path__ + "img/selected.e9540077.png";